'use client';

import * as React from 'react';
import mixpanel from 'mixpanel-browser';

export default function EventViewKahootAlternative() {
  React.useEffect(() => {
    mixpanel.track('kahoot_alt_landing_viewed');
  }, []);

  return null;
}
